import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider, useAppState, useFacet, useProductFilters } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"
import Checkbox from "./elements/Checkbox";
import Facets from "./elements/facetsData";

export default function RangeFacetCustom({ facet }) {
    const rangesArr = [
        { min: 1, max: 10, count: 0 },
        { min: 10, max: 25, count: 0 },
        { min: 25, max: 50, count: 0 },
        { min: 50, max: 75, count: 0 },
        { min: 75, max: 100, count: 0 },
    ]
    const {
        response: { products },
        loading
    } = useAppState()
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const [activeSelect, setActiveSelect] = useState(true);
    const [ranges, setRanges] = useState(rangesArr);
    const { filters } = useProductFilters()

    useEffect(() => {
        nostojs(api => {
            api.search({
                products: {
                    categoryId: products.categoryId,
                    categoryPath: products.categoryPath,
                    fields: ['price'],
                    size: products.total
                }
            }).then(response => {

                const updatedRanges = ranges.map(range => {
                    let productSelect = filters.length > 0 ? products : response.products
                    const count = productSelect.hits.filter(
                        product => product.price >= range.min && product.price <= range.max
                    ).length;
                    return { ...range, count };
                });
                setRanges(updatedRanges);

            }).catch(error => {
                console.error('Error:', error);
            });
        });
    }, [products]);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 768px)");
    
        const handleMediaChange = (e) => {
            setActiveSelect(e.matches);
        };
    
        handleMediaChange(mediaQuery);
    
        mediaQuery.addEventListener("change", handleMediaChange);
    
        return () => {
            mediaQuery.removeEventListener("change", handleMediaChange);
        };
    }, []);

    return (
        <li class={`ns-sidebar-dropdown pd-sidebar-dropdown ${activeSelect ? "ns-active" : ""}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-pt-4 ns-pb-2"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={() => setActiveSelect(!activeSelect)}
            >
                <span class="ns-color-black ns-font-5 pd-text-uppercase">{facet.name}</span>
                <Icon name="arrow" className="ns-absolute" />
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-py-4">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {ranges?.map((value) =>
                        value.count > 0 && (
                            <li
                                class="ns-d-flex ns-align-items-center ns-font-3"
                                data-nosto-element="facet-setting"
                            >
                                <Checkbox
                                    value={`$${value.min} - $${value.max}`}
                                    selected={value.min == range[0] && value.max == range[1]}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        updateRange([value.min, value.max]);
                                    }}
                                />
                                <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-color-black ns-border-radius-3">
                                    ({value.count})
                                </span>
                            </li>
                        )
                    )}
                </ul>
            </div>
        </li>
    )
}
